// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gx_t","buttons":"styles_buttons__2m-k8"};